import { Expose, Type } from 'class-transformer';
import { ViewContactDto } from '../../contacts/dto/view-contact.dto';
import { ViewShippingAddressDto } from './view-shipping-address.dto';

export class ViewShippingAddressExtendedDto extends ViewShippingAddressDto {
  @Expose() @Type(() => ViewContactDto) contacts: ViewContactDto[];
}
